<template>
<form class="filter" ref="form">
  <div class="filter__item">
    <input
      class="filter__search"
      placeholder="Vyhledat"
      type="text"
      id="filterSearch"
      name="filterSearch"
      v-model="filterSearch"
    />
    <router-link to="/info" class="btn btn--info">i</router-link>
  </div>
  <div class="filter__item">
    <span class="filter__switch">
      <div class="filter__switch__label">Pohlaví</div>
      <input
        value="0"
        type="radio"
        class="left"
        name="filterGender"
        id="gender-men"
        v-model="filterGender"
      />
      <label for="gender-men">muži</label>
      <input
        value="any"
        type="radio"
        class="center"
        name="filterGender"
        id="gender-any"
        v-model="filterGender"
      />
      <label for="gender-any">vše</label>
      <input
        value="1"
        type="radio"
        class="right"
        name="filterGender"
        id="gender-women"
        v-model="filterGender"
      />
      <label for="gender-women">ženy</label>
      <span class="filter__switch__actual" />
    </span>
  </div>
  <div class="filter__item">
    <span class="filter__switch">
      <div class="filter__switch__label">Věk</div>
      <input
        value="0"
        type="radio"
        class="left"
        name="filterAge"
        id="age-under"
        v-model="filterAge"
      />
      <label for="age-under">&lt;15</label>
      <input
        value="any"
        type="radio"
        class="center"
        name="filterAge"
        id="age-any"
        v-model="filterAge"
      />
      <label for="age-any">vše</label>
      <input
        value="1"
        type="radio"
        class="right"
        name="filterAge"
        id="age-over"
        v-model="filterAge"
      />
      <label for="age-over">&gt;15</label>
      <span class="filter__switch__actual" />
    </span>
  </div>
  <div class="filter__item">
    <span class="filter__switch">
      <div class="filter__switch__label">Přežili válku</div>
      <input
        :value="true"
        type="radio"
        class="left"
        name="filterSurvive"
        id="survive-yes"
        v-model="filterSurvive"
      />
      <label for="survive-yes">ano</label>
      <input
        value="any"
        type="radio"
        class="center"
        name="filterSurvive"
        id="survive-any"
        v-model="filterSurvive"
      />
      <label for="survive-any">vše</label>
      <input
        :value="false"
        type="radio"
        class="right"
        name="filterSurvive"
        id="survive-no"
        v-model="filterSurvive"
      />
      <label for="survive-no">ne</label>
      <span class="filter__switch__actual" />
    </span>
  </div>
  <div class="filter__item">
    <button
      @click.prevent="clearFilter"
      class="btn btn-clear"
    >
      Zrušit filter
    </button>
  </div>
</form>
</template>

<script>
export default {
  data() {
    return {
      filterAge: "any",
      filterGender: "any",
      filterSurvive: "any",
      filterSearch: ""
    };
  },
  watch: {
    filterAge() {
      this.changeFilter();
    },
    filterGender() {
      this.changeFilter();
    },
    filterSurvive() {
      this.changeFilter();
    },
    filterSearch() {
      this.changeFilter();
    }
  },
  methods: {
    clearFilter() {
      this.filterAge = "any";
      this.filterGender = "any";
      this.filterSurvive = "any";
      this.filterSearch = "";
      this.$refs.form.reset();
    },
    changeFilter() {
      this.$emit("filterChange", {
        filterAge: this.filterAge,
        filterGender: this.filterGender,
        filterSurvive: this.filterSurvive,
        filterSearch: this.filterSearch
      });
    }
  }
};
</script>

<style scoped>
.filter {
  display: flex;
  padding: 1rem;
  flex-wrap: wrap;
  align-items: flex-end;
  position: sticky;
  background-color: var(--colorWhite);
  top: 0;
  right: 0;
  border-bottom: 1px solid var(--colorBorder);
  z-index: 1;
  width: 100%;
}
@media (min-width: 768px) {
  .filter {
    /* width: calc(100% / 1.618); */
    align-items: center;
  }
}
@media (min-width: 992px) {
  .filter {
    padding: 1rem 1rem 0 1rem;
  }
}

.filter__item {
  width: calc(100% / 3);
  text-align: center;
}

.filter__item:first-child {
  width: 100%;
}

.filter__item:last-child {
  width: 100%;
}

.filter__search {
  width: calc(100% - (51px + 16px));
  font-size: 1.5rem;
  line-height: 1;
  padding: 0.5rem 1rem;
  font-family: inherit;
  margin-bottom: 1rem;
  background-color: var(--colorGray2);
  border: 0;
  border: 3px solid var(--colorGray2);
  color: var(--colorBase);
  outline: 0;
}

.filter__search:focus {
  /* box-shadow: 0 0 2px 0 var(--filter-bg); */
}

.filter {
  text-align: center;
  display: flex;
  justify-content: center;
}

.filter__switch {
  width: 6rem;
  display: flex;
  background-color: var(--colorWhite);
  border-radius: 2rem;
  height: 2rem;
  position: relative;
  margin: 2rem auto 1rem auto;
  color: var(--colorBase);
}

.filter__switch__label {
  position: absolute;
  width: 100%;
  text-align: center;
  left: 0;
  right: 0;
  top: -2rem;
  font-size: 1rem;
}

.filter__switch label {
  width: 2rem;
  text-align: center;
  line-height: 2rem;
  position: relative;
  z-index: 2;
  font-size: 0.8rem;
  cursor: pointer;
  color: var(--colorBase);
}

.filter__switch input {
  display: none;
}

.filter__switch__actual {
  position: absolute;
  z-index: 1;
  transform: translateX(100%);
  transition: transform 300ms ease-in-out;
  width: 2rem;
  top: 0;
  bottom: 0;
}

.filter__switch__actual:after {
  content: "";
  background-color: var(--colorPrimary);
  width: 2rem;
  height: 3px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 0.25rem;
}

.filter__switch input.left:checked ~ .filter__switch__actual {
  transform: translateX(0);
}
.filter__switch input.right:checked ~ .filter__switch__actual {
  transform: translateX(200%);
}

@media (min-width: 992px) {
  .filter__switch {
    width: 9rem;
  }

  .filter__switch__label {
    font-size: 1.25rem;
  }

  .filter__switch label {
    width: 3rem;
  }

  .filter__switch__actual {
    width: 3rem;
  }

  .filter__switch__actual:after {
    width: 3rem;
  }

  .filter__item {
    width: calc(100% / 4);
  }

  .filter__item:last-child {
    width: calc(100% / 4);
  }
}
</style>